var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActPhotoLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 25,
    viewBox: "0 0 13 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "act_photo-left",
    d: "M1.2109 14.5709L11.3322 24.7133C11.7132 25.095 12.3315 25.0956 12.7132 24.7147C13.095 24.3337 13.0957 23.7154 12.7147 23.3336L2.59269 13.1905C2.21193 12.8098 2.21193 12.1902 2.59342 11.8087L12.7147 1.66636C13.0957 1.28457 13.095 0.666256 12.7132 0.285299C12.5227 0.0950661 12.273 0 12.0234 0C11.7732 0 11.523 0.095602 11.3322 0.286764L1.21164 10.4284C0.0693512 11.5707 0.0693502 13.4293 1.2109 14.5709Z",
    fill: "#1E3799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActPhotoLeft);
export default __webpack_public_path__ + "static/media/act_photo-left.fc2497a04dd6a2a66af77ae244508721.svg";
export { ForwardRef as ReactComponent };